import { Typography } from "@mui/material"

const CustomStatusLabel = ({label, customStyles}) => {

      // Map labels to their respective colors
      const labelColors = {
        "verified": "green",
        "paid": "green",
        "completed": "#008000",
        "active": "green",
        "pending": "#FFA500",
        "expired": "#FF0000",
        "deleted": "red",
        "inactive": "red",
        "suspended": "#0178F2",
        "locked": "grey",
        "cancelled" : "red",
        "scheduled" : "#FFA500",
        "confirmed" : '#0178F2',
        "rescheduled" : "#0178F2",
        "approved": "green"
    };

    const normalizedLabel = String(label).toLowerCase();

    // Default color is red if label is not in the map
    const textColor = labelColors[normalizedLabel] || 'black';

    return (
        <div>
            <Typography sx={{
                ...customStyles, color: textColor 
            }}>
                {label}
            </Typography>
        </div>
    )
}

export default CustomStatusLabel